export const MEASURE_FIRST_POD_LOADED_HP_FINANCE = 'RETAIL_MTO_HP_FINANCE';
export const MEASURE_FIRST_POD_LOADED_HP_CASH = 'RETAIL_MTO_HP_CASH';
export const MEASURE_ORDER_PANEL_LOADED_BASKET_FINANCE = 'RETAIL_MTO_BSK_FINANCE';
export const MEASURE_ORDER_PANEL_LOADED_BASKET_CASH = 'SLA_CustomFMP';

export const MARK_SELECTOR_CONTINUE_CLICK = 'selector_continue_btn_clicked';
